import { motion } from 'motion/react'
import { mq, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.picture`
  ${({ theme }) => theme.textStyles.d1440_bodyBig} // for the alt
  display: block;
  color: ${({ theme }) => theme.colors.black}; // for the alt
  overflow: hidden;
`
export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`
export const MobileImage = styled(motion.create(Image))`
  @media ${mq(sizes.desktop)} {
    display: none;
  }
`
export const DesktopImage = styled(motion.create(Image))`
  &:not(:only-child) {
    display: none;
  }
  @media ${mq(sizes.desktop)} {
    &:not(:only-child) {
      display: block;
    }
  }
`
